import { useTranslation } from 'react-i18next'
import Input from "components/common/Input/Input"
import InputError from "components/common/InputError/InputError"

const CompanyZipCode = ({ register, error }) => {
  const { t } = useTranslation()

  return (
    <>
      <Input
        error={error}
        register={register('headquarterZipcode', {
          required: t('mainReporting:form.mandatory'),
          validate: value => /^\d{5}$/.test(value) || t('mainReporting:form.companyZipcode.errors.pattern')
        })}
        label={t('mainReporting:form.companyZipcode.label')}
        placeholder={t('mainReporting:form.companyZipcode.placeholder')}
        allowOnly={/\d/}
        maxLength={5}
      />
      <InputError error={error} />
    </>
  )
}

export default CompanyZipCode